export default function ({ to, from, next, app, router, store }) {
  next();
}
